import { api } from '@/shared/lib/api'
import type {
  CronLog,
  CronLogFilters,
  CronLogPaginatedResponse,
  CronEventFilters,
  CronEventPaginatedResponse,
} from '../types'

export const cronLogsService = {
  getAll: async (filters: CronLogFilters): Promise<CronLogPaginatedResponse> => {
    const params: Record<string, unknown> = {
      page: filters.page,
      limit: filters.limit,
    }
    if (filters.status) params.status = filters.status

    const { data } = await api.get('/cron_logs/', { params })
    return data
  },

  getById: async (id: number): Promise<CronLog> => {
    const { data } = await api.get(`/cron_logs/${id}`)
    return data
  },

  getEvents: async (
    executionId: number,
    filters: CronEventFilters,
  ): Promise<CronEventPaginatedResponse> => {
    const params: Record<string, unknown> = {
      page: filters.page,
      limit: filters.limit,
    }
    if (filters.event_type) params.event_type = filters.event_type
    if (filters.job_name) params.job_name = filters.job_name

    const { data } = await api.get(`/cron_logs/${executionId}/events`, { params })
    return data
  },
}
